/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandHtml5 = createReactComponent("outline", "brand-html5", "IconBrandHtml5", [["path", { "d": "M20 4l-2 14.5l-6 2l-6 -2l-2 -14.5z", "key": "svg-0" }], ["path", { "d": "M15.5 8h-7l.5 4h6l-.5 3.5l-2.5 .75l-2.5 -.75l-.1 -.5", "key": "svg-1" }]]);

export { IconBrandHtml5 as default };
//# sourceMappingURL=IconBrandHtml5.mjs.map
